import { AREAS, MAX_SCORE, band, fmtScore } from "@/lib/heat";

export const ScoreBreakdown = ({ scores, max = MAX_SCORE, extra, insights }) => (
  <div className="space-y-5" data-testid="score-breakdown">
    {AREAS.map((a) => {
      const v = Number(scores?.[a.key]) || 0;
      const b = band(v);
      const text = insights?.[a.key]?.[b.label];
      return (
        <div key={a.key} className="avoid-break" data-testid={`score-row-${a.key}`}>
          <div className="flex items-baseline justify-between gap-3">
            <span className="font-display text-base font-semibold text-slate-900">{a.label}</span>
            <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: b.hex }} data-testid={`score-level-${a.key}`}>
              {b.label}
            </span>
            <span className="ml-auto font-mono text-sm text-slate-700" data-testid={`score-value-${a.key}`}>
              {fmtScore(v)} / {max}
            </span>
          </div>
          <div className="mt-1.5 h-2.5 w-full overflow-hidden rounded-full bg-slate-100">
            <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${(v / max) * 100}%`, background: b.hex }} />
          </div>
          {extra && <div className="mt-1 text-xs text-slate-500 font-mono">{extra(a.key)}</div>}
          {text && (
            <p className="mt-2 text-sm leading-relaxed text-slate-600" data-testid={`score-insight-${a.key}`}>{text}</p>
          )}
        </div>
      );
    })}
  </div>
);
